import Icon from "@material-ui/core/Icon";
import ImagePreview from "./ImagePreview";
import Button from "@material-ui/core/Button";
import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import ActionsContainer from "./ActionsContainer";
import ToolbarContainer from "./ToolbarContainer";
import {usePriceList} from "../../../../Providers/PriceListProvider";
import {Trans, useTranslation} from "react-i18next";
import ToolbarContent from "./ToolbarContent";
import {Bubble, BubbleList} from "../../../Components/EditTemplateProduct/Components/Bubble";
import AppBar from "./AppBar";

const useStyles = makeStyles(theme => ({
  mainContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
}));

export default ({setCurrentPage, orderLine, onCancel, onComplete}) => {
  const { getProductByUuid, getWhiteBorderAlternativeProduct, getFormatSizeName} = usePriceList();
  const {t} = useTranslation();
  const classes = useStyles();
  const product = getProductByUuid(orderLine.product.uuid);

  return <div className={classes.mainContainer}>
    <AppBar onCancel={onCancel} />

    <ImagePreview orderLine={orderLine}/>

    <ToolbarContainer>
      <ToolbarContent>
        <BubbleList>
          <Bubble
              header={t('Format')}
              content={getFormatSizeName(product)}
              onClick={e => setCurrentPage('format')} />
          <Bubble
              header={t('Crop')}
              content={<Icon>crop_rotate</Icon>}
              onClick={e => setCurrentPage('crop')} />
          <Bubble
              header={t('Filter')}
              content={<Icon>photo_library</Icon>}
              onClick={e => setCurrentPage('filter')} />
          <Bubble
              header={t('Quantity')}
              content={t('%d pcs', {postProcess: 'sprintf', sprintf: [orderLine.quantity] })}
              onClick={e => setCurrentPage('quantity')} />
        </BubbleList>
      </ToolbarContent>

      <ActionsContainer>
        <Button color="primary" onClick={onCancel}>
          <Trans>Cancel</Trans>
        </Button>
        <Button color="primary" onClick={onComplete}><Trans>Done</Trans></Button>
      </ActionsContainer>
    </ToolbarContainer>
  </div>
}

